import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import BaseModal from './Base';
import Button from '../../Button';
import {_removeModal} from '../../../store';
import {parseErrorMessage} from '../../../utils/utils';
import DescriptiveText from '../../DescriptiveText';
import Row from '../../Row';
import sanitizeHtml from 'sanitize-html';

const ErrorModal = props => {
  const {title, err, button} = props.content;

  const actualTitle = (err.title || err?.response?.data?.error?.title !== undefined)
    ? err.title || err.response.data.error.title
    : title || 'Something Went Wrong'; // current copy Jeremy, this copy Rich 'An Issue Occurred';

  const executeAction = () => {
    if (button && button.action) {
      button.action(button.data);
    }
    props.dispatchRemoveModal(props.content);
  };

  return <BaseModal onClose={() => props.dispatchRemoveModal(props.content)} title={actualTitle}>
    <DescriptiveText>
      <span dangerouslySetInnerHTML={{__html: sanitizeHtml(parseErrorMessage(err))}}/>
    </DescriptiveText>
    <Row wrap={true}>
      <Button
        importance={'primary'}
        size={'md'}
        label={(button && button.text) || 'OK'}
        disabled={false}
        action={executeAction}>
      </Button>
    </Row>
  </BaseModal>;
};

const mapDispatchToProps = dispatch => ({
  dispatchRemoveModal: modal => {
    dispatch(_removeModal(modal));
  },
});

export default connect(null, mapDispatchToProps)(ErrorModal);

ErrorModal.propTypes = {
  content: PropTypes.shape({
    id: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    err: PropTypes.shape({
      title: PropTypes.string,
      msg: PropTypes.string,
      response: PropTypes.shape({
        data: PropTypes.shape({
          error: PropTypes.shape({
            title: PropTypes.string,
            msg: PropTypes.string,
          }),
        }),
      }),
      message: PropTypes.string,
    }).isRequired,
    body: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.element,
    ]).isRequired,
    button: PropTypes.shape({
      text: PropTypes.string,
      action: PropTypes.func,
      data: PropTypes.object,
    }),
  }).isRequired,
  dispatchRemoveModal: PropTypes.func.isRequired,
};
